module.exports = __webpack_public_path__ + "media/images/save-money-lady-359f6f03.jpg";